module.exports = __webpack_public_path__ + "static/media/logoGlobalInfo.9855576c.png";